import React from 'react';
import type { JobPath } from './types';
import { TOOL_REGISTRY } from './jobPaths';
import { OffRampStepFrame } from './OffRampStepFrame';

export function OffRampPathView({ job }: { job: JobPath }) {
    return (
        <div className="space-y-6" data-testid={`offramp-path-${job.id}`}>
            <div>
                <h2 className="text-sm font-semibold text-foreground">{job.title}</h2>
                <p className="text-xs text-muted-foreground mt-0.5">{job.blurb}</p>
            </div>
            {job.steps.map((step, index) => {
                const Panel = TOOL_REGISTRY[step.toolId];
                if (!Panel) return null;
                const emphasizeExample = step.toolId === job.primaryToolId;
                return (
                    <OffRampStepFrame
                        key={`${job.id}-${step.toolId}-${index}`}
                        stepNumber={index + 1}
                        title={step.title}
                        hint={step.hint}
                        engTag={step.engTag}
                        optional={step.required === false}
                    >
                        <Panel emphasizeExample={emphasizeExample} />
                    </OffRampStepFrame>
                );
            })}
        </div>
    );
}
